/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ channel: NonNullable<unknown> }} Sharecopylink2Inputs */

const en_sharecopylink2 = /** @type {(inputs: Sharecopylink2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy the “${i?.channel}” link`)
};

const de_sharecopylink2 = /** @type {(inputs: Sharecopylink2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link „${i?.channel}“ kopieren`)
};

/**
* | output |
* | --- |
* | "Copy the “{channel}” link" |
*
* @param {Sharecopylink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharecopylink2 = /** @type {((inputs: Sharecopylink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharecopylink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharecopylink2(inputs)
	return de_sharecopylink2(inputs)
});
export { sharecopylink2 as "shareCopyLink" }